<template>
    <div>
        <Header/>
        <div class="wrapper-top-margin">
            <div class="container">
                <div class="row">
                    <div class="col-12">
                        <div class="ns-card">
                            <h5 class="font-weight-light">Some Of Our Apps Links</h5>
                            <div class="single-link">
                                <a target="_blank" href="https://www.isunaslabs.com/files/news.apk">Kenya News</a>
                            </div>
                            <div class="single-link">
                                <a target="_blank" href="https://www.isunaslabs.com/files/natakakazi.apk">NatakaKazi</a>
                            </div>
                            <div class="single-link">
                                <a target="_blank" href="https://www.isunaslabs.com/files/animal-sounds.apk">Animal Sounds</a>
                            </div>
                            <div class="single-link">
                                <a target="_blank" href="https://www.isunaslabs.com/files/kids-numbers.apk">Kids Numbers</a>
                            </div>
                            <div class="single-link">
                                <a target="_blank" href="https://www.isunaslabs.com/files/kids-drawing.apk">Kids Drawing</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Header from "../components/Header"
export default {
    components: {
        Header
    }
}
</script>

<style lang="scss" scoped>
    @import "../partials";
    @import "../mixins";
   .ns-card {
       @include card;
   } 
</style>